import { takeEvery, put, call, fork } from 'redux-saga/effects';
import { Client } from '../../utils/client';
import {
  SEARCH_PRODUCT_FILTER,
  searchProductFilterSuccess,
  TIER_FEE_ON_LOAD,
  tierFeeOnFailed,
  tierFeeOnSuccess,
  CORRIDOR_REF_ON_LOAD,
  corridorReferencesOnSuccess,
  corridorReferencesOnFailed,
  PRODUCT_UPDATE_ON_LOAD,
  updateProductOnSuccess,
  updateProductOnFailed,
  UPDATE_TIER_FEE,
  updateTierFeeOnSuccess,
  updateTierFeeOnFailed,
  REQUEST_SELECTED_HUB_ON_LOAD,
  requestSelectedHubOnSuccess,
  requestSelectedHubOnFailed,
  ADD_NEWBANK_TO_CORRIDOR,
  ADD_NEWBANK_TO_CORRIDORS,
  addNewBankToCorridorSuccess,
  addNewBankToCorridorsSuccess,
  UPDATE_BANK_IN_CORRIDOR,
  updateBankInCorridorSuccess,
  ADD_NEWBANK_TO_ISSUERML,
  addNewBankToIssuerMLSuccess,
  UPDATE_BANK_IN_ISSUERML,
  updateBankInIssuerMLSuccess,
  ISSUER_ML_FETCH,
  issuerMLDataFetchSuccess,
  ISSUER_FETCH,
  issuerDataFetchSuccess,
  SUBMIT_TIER_FEE_REQUEST,
  FETCH_REQUEST_FLOW,
  submitTierFeeRequestSuccess,
  fetchRequestFlowSuccess,
  FETCH_ISSUERS_BY_COUNTRY_STATUS,
  fetchIssuersByCountryStatusSuccess,
  fetchIssuersByCountryStatusFailed,
  requestIssuersByCountryStatusSuccess,
  requestIssuersByCountryStatusFailed,
  REQUEST_ISSUERS_BY_COUNTRY_STATUS,
  FETCH_WALLETS_BY_COUNTRY_STATUS,
  fetchWalletsByCountryStatusSuccess,
  fetchWalletsByCountryStatusFailed,
  REQUEST_WALLETS_BY_COUNTRY_STATUS,
  requestWalletsByCountryStatusSuccess,
  requestWalletsByCountryStatusFailed,
  recievingCountriesOnSuccess,
  recievingCountriesOnFailed,
  RECIEVING_COUNTRIES_ON_LOAD
} from './actions';
import { appLogout } from '../../redux-root/actions';
import { getRequestMessageNum } from 'components/SideMenu/saga';

export function* searchFilter(action) {
  try {
    const params = Object.assign({}, action.payload);
    const queryString = new URLSearchParams(params).toString();

    const data = yield call(Client.getData, `/api/v2/products/remit-services?${queryString}`, true);

    yield put(searchProductFilterSuccess(data));
  } catch (error) {
    if (error.status === 401) {
      yield put(appLogout(true));
    }
  }
}

export function* getTierFee(action) {
  try {
    const serviceId = action.payload
    const data = { serviceId: serviceId }
    data.additional = yield call(Client.getData, `/api/v2/products/remit-services/${serviceId}/tier-fees`, true);
    yield put(tierFeeOnSuccess(data));
  } catch (error) {
    if (error.status === 401) {
      yield put(appLogout(true));
    } else {
      yield put(tierFeeOnFailed(error));
    }
  }
}

export function* getRecievingCountries() {
  try {
    const data= yield call(Client.getData, "/api/v1/utility/receivingcountries");
    yield put(recievingCountriesOnSuccess(data));
  } catch (error) {
    if (error.status === 401) {
      yield put(appLogout(true));
    } else {
      yield put(recievingCountriesOnFailed(error));
    }
  }
}

export function* getCorridorReferences(action) {
  try {
    const serviceId = action.payload
    const data = { serviceId: serviceId }
    data.additional = yield call(Client.getData, `/api/v2/products/remit-services/${serviceId}/corridor-references`, true);

    yield put(corridorReferencesOnSuccess(data));
  } catch (error) {
    if (error.status === 401) {
      yield put(appLogout(true));
    } else {
      yield put(corridorReferencesOnFailed(error));
    }
  }
}

export function* updateProduct(action) {
  try {
    const serviceId = action.payload.remitServiceId;
    const data = yield call(Client.patchData, `/api/v1/products/${serviceId}/activation`, action.payload.request);
    yield put(updateProductOnSuccess(data));
  } catch (error) {
    if (error.status === 401) {
      yield put(appLogout(true));
    } else {
      yield put(updateProductOnFailed(error));
    }
  }
}

export function* updateProductTierFee(action) {
  try {
    const serviceId = action.payload.remitServiceId;
    const data = yield call(Client.putData, `/api/v2/products/remit-services/{0}/tier-fees`, action.payload.request.tierFees, true, { 'isListObject': true, 'id': serviceId });
    yield put(updateTierFeeOnSuccess(data));
  } catch (error) {
    if (error.status === 401) {
      yield put(appLogout(true));
    } else {
      yield put(updateTierFeeOnFailed(error));
    }
  }
}

export function* addNewBankToCorridors(action) {
  try {
    let data = yield call(Client.postData, `/api/v2/products/remit-services/corridor-references/list`, action.payload, true, { 'isListObject': true });
    yield put(addNewBankToCorridorsSuccess(data));

  } catch (error) {
    if (error.status === 401) {
      yield put(appLogout(true));
    }
  }
}



export function* addNewBankToCorridor(action) {
  try {
    let data = yield call(Client.postData, `/api/v2/products/remit-services/corridor-references/list`, action.payload, true, { 'isListObject': false });
    yield put(addNewBankToCorridorSuccess(data));

  } catch (error) {
    if (error.status === 401) {
      yield put(appLogout(true));
    }
  }
}

export function* updateBankInCorridor(action) {
  try {
    let data = yield call(Client.putData, `/api/v2/products/remit-services/corridor-references`, action.payload, true, { 'isListObject': false });
    yield put(updateBankInCorridorSuccess(data));

  } catch (error) {
    if (error.status === 401) {
      yield put(appLogout(true));
    }
  }
}

export function* addNewBankToIssuerML(action) {
  try {
    let data = yield call(Client.postData, `/api/v1/utility/issuers/list`, action.payload, true, { 'isListObject': true });
    yield put(addNewBankToIssuerMLSuccess(data));

  } catch (error) {
    if (error.status === 401) {
      yield put(appLogout(true));
    }
  }
}

export function* updateBankInIssuerML(action) {

  try {
    let data = yield call(Client.putData, `/api/v1/utility/issuers`, action.payload, true, { 'isListObject': false });
    yield put(updateBankInIssuerMLSuccess(data));

  } catch (error) {
    if (error.status === 401) {
      yield put(appLogout(true));
    }
  }
}

export function* issuerMLDataFetch(action) {

  try {
    const { mobileOperatorId, foreignCountryId } = action.payload;
    const data = { mobileOperatorId: mobileOperatorId, countryId: foreignCountryId }
    data.additional = yield call(Client.getData, `/api/v1/utility/issuers/${mobileOperatorId}/${foreignCountryId}`, true);
    yield put(issuerMLDataFetchSuccess(data));

  } catch (error) {
    if (error.status === 401) {
      yield put(appLogout(true));
    }
  }
}

export function* issuerDataFetch(action) {

  try {
    const { mobileOperatorId, foreignCountryId } = action.payload;

    const data = { mobileOperatorId: mobileOperatorId, countryId: foreignCountryId }
    data.additional = yield call(Client.getData, `/api/v1/utility/issuers/${mobileOperatorId}/0?countryId=${foreignCountryId}`, true);

    yield put(issuerDataFetchSuccess(data));

  } catch (error) {

    if (error.status === 401) {
      yield put(appLogout(true));
    }
  }
}

export function* requestSelectedHub(action) {
  try {
    const data = yield call(Client.postData, `/api/v1/portal/requests`, action.payload);
    yield put(requestSelectedHubOnSuccess(data));
    yield call(getRequestMessageNum);
  } catch (error) {
    if (error.status === 401) {
      yield put(appLogout(true));
    } else {
      yield put(requestSelectedHubOnFailed(error));
    } 
  }
}

export function* submitTierFeeRequest(action) {
  try {
    const data = yield call(Client.postData, `/api/v1/portal/requests`, action.payload, true);
     yield put(submitTierFeeRequestSuccess(data));
  } catch (error) {
     if (error.status === 401) {
      yield put(appLogout(true));
    } 
  }
}

export function* fetchRequestFlowSaga() {
  try {
    const response = yield call(Client.getData, '/api/v1/portal/flows');
    const flows = Array.isArray(response?.data) ? response.data : response;
    const updateTierFeeFlow = flows.find(flow => flow.name === 'UPDATE_TIER_FEE');
    
    if (updateTierFeeFlow) {
     yield put(fetchRequestFlowSuccess(updateTierFeeFlow.id));
    } 
  } catch (error) {
      if (error.status === 401) {
      yield put(appLogout(true));
    }
  }
}

export function* fetchIssuersByCountryStatusSaga(action) {
  try {
    const countryId = action.payload.countryId;
    const status = action.payload.status;
    const response = yield call(Client.getData, status === 'null'? `/api/v1/utility/issuers?countryId=${countryId}` : `/api/v1/utility/issuers?countryId=${countryId}&status=${status}`);
    const data = Array.isArray(response?.data) ? response.data : response;
    
    yield put(fetchIssuersByCountryStatusSuccess(data));
  } catch (error) {
    if (error.status === 401) {
      yield put(appLogout(true));
    }else {
      yield put(fetchIssuersByCountryStatusFailed(error));
    } 
  }
}

export function* requestIssuersByCountryStatusSaga(action) {
  try {
    const response = yield call(Client.postData, `/api/v1/portal/requests`, action.payload, true);
    if (response.message){
      yield put(requestIssuersByCountryStatusSuccess(response))
    }
  } catch (error) {
    if (error.status === 401) {
      yield put(appLogout(true));
    }else {
      yield put(requestIssuersByCountryStatusFailed(error));
    } 
  }
}

export function* fetchWalletServicesByCountryStatusSaga(action) {
  try {
    const countryId = action.payload.countryId;
    const status = action.payload.status;
    const response = yield call(Client.getData, status == null? `/api/v2/products/remit-services?serviceType=3&foreignCountryId=${countryId}` : `/api/v2/products/remit-services?serviceType=3&foreignCountryId=${countryId}&status=${status}`);
    const data = Array.isArray(response?.data) ? response.data : response;
    
    yield put(fetchWalletsByCountryStatusSuccess(data));
  } catch (error) {
    if (error.status === 401) {
      yield put(appLogout(true));
    }else {
      if(error.data&& error.data.length>0&&error.data[0].code==8002){
        yield put(fetchWalletsByCountryStatusFailed({message: 'No Service found.'}));
      }else{
        yield put(fetchWalletsByCountryStatusFailed(error));
      }
    } 
  }
}

export function* requestWalletsByCountryStatusSaga(action) {
  try {
    const response = yield call(Client.postData, `/api/v1/portal/requests`, action.payload);
    if (response.message){
      yield put(requestWalletsByCountryStatusSuccess(response))
    }
  } catch (error) {
    if (error.status === 401) {
      yield put(appLogout(true));
    }else {
      yield put(requestWalletsByCountryStatusFailed(error));
    } 
  }
}

function* watchProductApis() {
  yield takeEvery(SEARCH_PRODUCT_FILTER, searchFilter);
  yield takeEvery(TIER_FEE_ON_LOAD, getTierFee);
  yield takeEvery(RECIEVING_COUNTRIES_ON_LOAD, getRecievingCountries);
  yield takeEvery(CORRIDOR_REF_ON_LOAD, getCorridorReferences);
  yield takeEvery(PRODUCT_UPDATE_ON_LOAD, updateProduct);
  yield takeEvery(UPDATE_TIER_FEE, updateProductTierFee);
  yield takeEvery(ADD_NEWBANK_TO_CORRIDOR, addNewBankToCorridor);
  yield takeEvery(ADD_NEWBANK_TO_CORRIDORS, addNewBankToCorridors);
  yield takeEvery(UPDATE_BANK_IN_CORRIDOR, updateBankInCorridor);
  yield takeEvery(ADD_NEWBANK_TO_ISSUERML, addNewBankToIssuerML);
  yield takeEvery(UPDATE_BANK_IN_ISSUERML, updateBankInIssuerML);
  yield takeEvery(ISSUER_ML_FETCH, issuerMLDataFetch);
  yield takeEvery(ISSUER_FETCH, issuerDataFetch);
  yield takeEvery(SUBMIT_TIER_FEE_REQUEST, submitTierFeeRequest);
  yield takeEvery(FETCH_REQUEST_FLOW, fetchRequestFlowSaga);
  yield takeEvery(FETCH_ISSUERS_BY_COUNTRY_STATUS, fetchIssuersByCountryStatusSaga);
  yield takeEvery(REQUEST_ISSUERS_BY_COUNTRY_STATUS, requestIssuersByCountryStatusSaga);
  yield takeEvery(FETCH_WALLETS_BY_COUNTRY_STATUS, fetchWalletServicesByCountryStatusSaga);
  yield takeEvery(REQUEST_SELECTED_HUB_ON_LOAD, requestSelectedHub);
  yield takeEvery(REQUEST_WALLETS_BY_COUNTRY_STATUS, requestWalletsByCountryStatusSaga);
}

export function* productSaga() {
  yield fork(watchProductApis);
}